import { PageDefinition } from "@cervval.js/client-html5-spa/navigation";
import { ObjectTools } from "@cervval.js/common/tools";
import { PRO_PS } from "@ehealth_tools/common-booking/src/permissions/permissionString";
import { BookingPages } from "../../../page.i18n";

// PERMISSION : must have BOOKING_PERMISSIONS.PRO string

export const productsPages = {
    "products": ObjectTools.is<PageDefinition>({
        importPromise: () => { return import("./productPage").then((module) => new module.ProductPage()); },
        menuItem: {
            label: BookingPages().myProducts,
            iconClasses: "fa-regular fa-box"
        },
        menus: [
            {
                menuUid: "proMenu",
                order: 1,
                sectionUid: "mainSection"
            }
        ],
        permissions: [PRO_PS]
    })
};